import {
  Component,
  Input,
  Output,
  OnInit,
  EventEmitter,
  OnDestroy,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
  ChangeDetectorRef,
  HostListener
} from '@angular/core';
import { VwdOption } from '@vwd/vwd-pilldown';
import { BarChartValue, TooltipValue, CashFlowItem, CashFlowData } from './result-box.model';
import { BondData } from '../bond-calculator.model';
import * as Highcharts from 'highcharts';
import { TranslateService } from '@ngx-translate/core';
import { FormattingService, toDateOrDefault } from '@vwd/ngx-i18n';

const colors = ['#00C6fb', '#bbcb56', '#e68c2c', '#fbbe0d', '#e47cff', '#ec5780',
  '#f5321b', '#53c973', '#395760', '#fff', '#e6eaec', '#000', '#ee6174'];

@Component({
  selector: 'result-box',
  templateUrl: './result-box.component.html',
  styleUrls: ['./result-box.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResultBoxComponent implements OnInit, OnDestroy {

  @ViewChild('container') container: ElementRef;
  @ViewChild('resultContent') resultContent: ElementRef;

  @Output() viewChanged = new EventEmitter<string>();

  @Input()
  set bondData(value: BondData) {



    if (value) {
      this._bondData = value;

      if (!this._bondData.resultBox.defaultConfig) {

        if (!this.bondData.resultBox.cashflowItem) {
          this.noDataFound = true;
        } else {
          this.noDataFound = false;
          this.generateCashflowList(this.bondData.resultBox.cashflowItem,
            this.bondData.resultBox.totalAccurateInterest,
            typeof this.bondData.settingsBox.nominalVolume === 'string'
              ? this.formattingService.parseFloat(this.bondData.settingsBox.nominalVolume)
              : this.bondData.settingsBox.nominalVolume);

          //  if (this.view === 'grafic') {
          setTimeout(() => {
            this.createChart();
            this.getChartData();
          }, 0);

          // }
        }
      }
    }
  }

  get bondData(): BondData {
    return this._bondData;
  }

  cuponValue: number;

  profit: number;

  cashFlowList: CashFlowItem[];

  noDataFound: boolean;

  viewOpt: VwdOption[] = [];

  view = 'figures';

  readonly currencyIsoAlpha3 = 'EUR';

  private plotBand: any = {};

  // tslint:disable-next-line:variable-name
  private _bondData: BondData;

  private chart: any;

  @HostListener('window:resize') onResize() {
    if (this.resultContent && this.chart) {
      this.chart.reflow();
    }
  }

  constructor(
    private cdRef: ChangeDetectorRef,
    private translate: TranslateService,
    private formattingService: FormattingService
  ) { }

  ngOnInit() {
    setTimeout(() => {

      this.viewOpt = [
        new VwdOption(this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.RESULT_BOX.CHART_VIEW.VIEW_OPTIONS.FIGURES'), 'figures'),
        new VwdOption(this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.RESULT_BOX.CHART_VIEW.VIEW_OPTIONS.CASH_FLOW'), 'cashflow'),
        new VwdOption(this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.RESULT_BOX.CHART_VIEW.VIEW_OPTIONS.GRAFIC'), 'grafic'),
      ];

      this.view = this.viewOpt[0].value;

      this.plotBand = {
        id: 'plotband',
        color: colors[0],
        from: 2.5,
        to: 3.5,
        zIndex: 3,
        borderColor: 'transparent',
        borderWidth: 1,
        label: {
          text: this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.RESULT_BOX.CHART_VIEW.CHART.PLOT_BAND_TEXT'),
          rotation: -90,
          textAlign: 'right',
          style: {
            color: '#fff',
            fontSize: '1rem',
          }

        }
      };
      this.cdRef.markForCheck();
    }, 50);

  }


  changeView(event: string) {
    this.view = event;
    this.viewChanged.emit(this.view);

    if (this.view === 'grafic' && !this._bondData.resultBox.defaultConfig) {
      if (!this.bondData.resultBox.cashflowItem) {
        this.noDataFound = true;
      } else {
        this.noDataFound = false;
        this.createChart();
        this.getChartData();
      }

    } else if (this.view === 'cashflow' && !this._bondData.resultBox.defaultConfig) {
      if (!this.bondData.resultBox.cashflowItem) {
        this.noDataFound = true;
      } else {
        this.generateCashflowList(this.bondData.resultBox.cashflowItem,
          this.bondData.resultBox.totalAccurateInterest,
          typeof this.bondData.settingsBox.nominalVolume === 'string'
            ? this.formattingService.parseFloat(this.bondData.settingsBox.nominalVolume)
            : this.bondData.settingsBox.nominalVolume);
      }
    }

  }

  private createChart(): void {

    if (this.chart) {
      this.chart.destroy();
    }

    const self = this;
    const chartOptions = Highcharts.merge({

      chart: {
        type: 'column',
        renderTo: this.container.nativeElement,
        marginTop: 50,
        marginLeft: 0,
        marginRight: 0
      },

      plotOptions: {
        series: {
          stacking: 'normal',
          animation: true,
        },
        column: {
          stacking: 'normal',
          minPointLength: 10,
          pointWidth: 40
        }
      },
      title: {
        text: ' '
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      xAxis: {
        categories: null,
        labels: {
          staggerLines: 1,
          style: {
            fontSize: '1rem'
          }
        },
        plotBands: [],
        crosshair: true
      },
      yAxis: {
        title: {
          text: null
        },
        labels: {
          enabled: false
        },
        gridLineColor: null,
        plotLines: [{
          color: '#e6e6e6',
          width: 1,
          value: 0
        }]
      },
      tooltip: {
        shared: true,
        useHTML: true,
        formatter: function () {
          // tslint:disable:max-line-length
          return `
                <div class="tooltip-shell">
                  <p>${this.points[0].point.info.type} <span class="date">(${this.points[0].point.name})</span></p>
                  <p>${self.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.RESULT_BOX.CHART_VIEW.CHART.TOOLTIP.AMOUNT')}<span class="number">
                    ${this.points[0].point.info.calc} ${self.currencyIsoAlpha3}
                  </span></p>
                  <div class="tooltip-line"></div>
                  <p>${self.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.RESULT_BOX.CHART_VIEW.CHART.TOOLTIP.SALDO')} <span class="number">
                    ${self.formattingService.formatNumber(this.points[0].point.info.saldo, '1.2-2')} ${self.currencyIsoAlpha3}
                  </span></p>
                </div>
              `;
          // tslint:enable:max-line-length
        }
      },

      series: [{
        data: []
      },
      {
        data: []
      }]

    });

    this.chart = Highcharts.chart(chartOptions);
    this.chart.reflow();
  }

  private getChartData(): void {
    const count: number = this.bondData.resultBox.cashflowItem.length;
    const categories = [];
    const stackedBarsData = [];
    const data = [];
    const tooltipValues: TooltipValue[] = this.getTooltipValues(this.bondData.resultBox.cashflowItem.slice(0));

    this.cuponValue = this.bondData.resultBox.cashflowItem[this.bondData.resultBox.cashflowItem.length - 1].cashValue * 1000;

    this.bondData.resultBox.cashflowItem.forEach((item, index) => {
      const itemDate = this.formattingService.formatDateTime(item.date, 'mediumDate');

      if (count > 6 && index === 3) {
        categories.push('...');
        data.push(null);
        stackedBarsData.push(null);
      }

      if (count > 6 && index > 2 && index < (count - 3)) {
        return;
      }

      let value = +item.presentValue;
      let color = colors[0];
      let tooltip = tooltipValues[index];

      if (index === 0) {
        value += item.cashValue * 1000;
        color = colors[12];
        tooltip = tooltipValues[0];
      }

      if (index === this.bondData.resultBox.cashflowItem.length - 1) {
        color = colors[12];
      }

      categories.push(itemDate);
      data.push(new BarChartValue(itemDate, value, color, tooltip));
      stackedBarsData.push(null);

    });

    const repayment: BarChartValue = data[data.length - 1];

    const lastDate = repayment.name;

    this.profit = +repayment.info.saldo;

    categories.push(lastDate);
    data.push(new BarChartValue(
      lastDate,
      this.profit,
      colors[7],
      new TooltipValue(
        this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.RESULT_BOX.CHART_VIEW.CHART.TOOLTIP.PROFIT'),
        this.formattingService.formatNumber(repayment.info.saldo, '1.2-2'),
        repayment.info.saldo,
        '#a6e7a6'
      )
    ));

    stackedBarsData.push(null);

    stackedBarsData[0] = { y: this.bondData.resultBox.totalAccurateInterest, color: '#f1aeb7' };
    stackedBarsData[data.length - 2] = {
      y: this.bondData.resultBox.cashflowItem[count - 1].cashValue * 1000,
      color: colors[0]
    };

    setTimeout(() => {
      this.setPlotBand(data);
      this.chart.xAxis[0].setCategories(categories);
      this.chart.series[0].setData(data);
      this.chart.series[1].setData(stackedBarsData);
    }, 0);
  }

  private getTooltipValues(cashflowItems: CashFlowData[]): TooltipValue[] {

    const data: TooltipValue[] = [];
    const buyPresent = cashflowItems.shift().presentValue;
    const nominalVolume = typeof this.bondData.settingsBox.nominalVolume === 'string'
      ? this.formattingService.parseFloat(this.bondData.settingsBox.nominalVolume)
      : this.bondData.settingsBox.nominalVolume as number;

    data.push(new TooltipValue(
      this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.RESULT_BOX.CHART_VIEW.CHART.TOOLTIP.PURCHASE_ACCURATE_INTEREST'),
      // tslint:disable-next-line:max-line-length
      `${this.formattingService.formatNumber(buyPresent - this.bondData.resultBox.totalAccurateInterest, '1.2-2')} / ${this.formattingService.formatNumber(this.bondData.resultBox.totalAccurateInterest, '1.2-2')}`,
      buyPresent,
      '#ee6174'
    ));

    cashflowItems.forEach((item: CashFlowData, index: number) => {
      data.push(new TooltipValue(
        this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.RESULT_BOX.CHART_VIEW.CHART.TOOLTIP.COUPON_PAYMENT'),
        `${this.formattingService.formatNumber(item.presentValue, '1.2-2')}`,
        data[index].saldo + item.presentValue,
        '#9494c7'));
    });

    const lastKupon = this.bondData.resultBox.cashflowItem[this.bondData.resultBox.cashflowItem.length - 1];
    const kuponValue = lastKupon.cashValue * 1000 * (lastKupon.couponFactor || 1);
    const saldo = data[data.length - 1].saldo + kuponValue;

    data.push(new TooltipValue(
      this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.RESULT_BOX.CHART_VIEW.CHART.TOOLTIP.COUPON_PAYMENT_REPAYMENT'),
      `${nominalVolume} / ${kuponValue}`,
      (nominalVolume + saldo),
      '#21a65f'));

    return data;
  }

  private setPlotBand(data: BarChartValue[]) {
    if ((data.length - 1) > 6) {
      this.chart.xAxis[0].addPlotBand(this.plotBand);
    } else if (this.chart.xAxis[0].plotLinesAndBands[0]) {
    }
  }

  private generateCashflowList(cashflow: CashFlowData[], totalAccurateInterest: number, nominalVolume: number) {

    const cashFlowList: CashFlowItem[] = [];
    const cleanPrice = (cashflow[0].presentValue - totalAccurateInterest);
    let saldo: number = cleanPrice + totalAccurateInterest;
    let lastCouponDate;
    let gewinn;

    cashFlowList.push(new CashFlowItem(
      toDateOrDefault(cashflow[0].date),
      this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.RESULT_BOX.CASH_FLOW_VIEW.CASH_FLOW_ITEM.PURCHASE'),
      cleanPrice,
      cleanPrice,
      ((cleanPrice / nominalVolume) * 100),
      ((cleanPrice / nominalVolume) * 100),
    ));

    cashFlowList.push(new CashFlowItem(
      toDateOrDefault(cashflow[0].date), // format to template
      this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.RESULT_BOX.CASH_FLOW_VIEW.CASH_FLOW_ITEM.ACCURATE_INTEREST'),
      totalAccurateInterest,
      saldo,
      ((totalAccurateInterest / nominalVolume) * 100),
      ((saldo / nominalVolume) * 100),
    ));

    cashflow.forEach((row: CashFlowData, currentIndex: number) => {
      if (currentIndex !== 0 && currentIndex < (cashflow.length - 1)) {
        saldo += row.presentValue;

        cashFlowList.push(new CashFlowItem(
          toDateOrDefault(cashflow[currentIndex].date), // format to template
          this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.RESULT_BOX.CASH_FLOW_VIEW.CASH_FLOW_ITEM.COUPON_PAYMENT'),
          row.presentValue,
          saldo,
          ((row.presentValue / nominalVolume) * 100),
          ((saldo / nominalVolume) * 100),
        ));
      } else if (currentIndex === (cashflow.length - 1)) {
        saldo += row.presentValue - nominalVolume;
        lastCouponDate = row.date;

        cashFlowList.push(new CashFlowItem(
          toDateOrDefault(cashflow[currentIndex].date), // format to template
          this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.RESULT_BOX.CASH_FLOW_VIEW.CASH_FLOW_ITEM.COUPON_PAYMENT'),
          row.cashValue * 1000,
          saldo,
          ((row.cashValue * 1000 / nominalVolume) * 100),
          ((saldo / nominalVolume) * 100),
        ));
      }
    });

    gewinn = saldo + nominalVolume;

    cashFlowList.push(new CashFlowItem(
      lastCouponDate,
      this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.RESULT_BOX.CASH_FLOW_VIEW.CASH_FLOW_ITEM.REPAYMENT'),
      nominalVolume,
      gewinn,
      ((nominalVolume / nominalVolume) * 100),
      ((gewinn / nominalVolume) * 100),
    ));

    cashFlowList.push(new CashFlowItem(
      lastCouponDate, // format to template
      this.translate.instant('WIDGETS.BOND_CALCULATOR.CONTENT.RESULT_BOX.CASH_FLOW_VIEW.CASH_FLOW_ITEM.PROFIT'),
      gewinn,
      gewinn,
      ((gewinn / nominalVolume) * 100),
      ((gewinn / nominalVolume) * 100),
    ));

    this.cashFlowList = cashFlowList;
  }

  ngOnDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
}

